module.exports = __webpack_public_path__ + "img/add-circle.71089a1f.svg";